import React, { useEffect, useState, createContext, useContext } from 'react';
interface TableOrderState {
  tableId: string;
  tableNumber: string;
  tableName: string;
  restaurantSlug: string;
  restaurantId: string;
  orderChannel: 'qr' | 'waiter';
}
interface TableOrderContextType {
  tableOrder: TableOrderState | null;
  isTableOrder: boolean;
  setTableOrder: (state: TableOrderState) => void;
  clearTableOrder: () => void;
}
const TableOrderContext = createContext<TableOrderContextType | undefined>(undefined);
const TABLE_ORDER_KEY = 'noiza_table_order';
export function TableOrderProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [tableOrder, setTableOrderState] = useState<TableOrderState | null>(() => {
    try {
      const saved = localStorage.getItem(TABLE_ORDER_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  useEffect(() => {
    if (tableOrder) {
      localStorage.setItem(TABLE_ORDER_KEY, JSON.stringify(tableOrder));
    } else {
      localStorage.removeItem(TABLE_ORDER_KEY);
    }
  }, [tableOrder]);
  const setTableOrder = (state: TableOrderState) => {
    setTableOrderState(state);
  };
  const clearTableOrder = () => {
    setTableOrderState(null);
    localStorage.removeItem(TABLE_ORDER_KEY);
  };
  return <TableOrderContext.Provider value={{
    tableOrder,
    isTableOrder: !!tableOrder,
    setTableOrder,
    clearTableOrder
  }} data-id="element-1436">
      {children}
    </TableOrderContext.Provider>;
}
export function useTableOrder() {
  const context = useContext(TableOrderContext);
  if (context === undefined) {
    throw new Error('useTableOrder must be used within a TableOrderProvider');
  }
  return context;
}